import type { PublicApiKey } from '#packages/apilib';
import type { createEditorCoreApi } from './api';

export const EditorCoreApiKey: PublicApiKey<typeof createEditorCoreApi> = {
  name: 'EditorCoreApi',
  public: true,
};
